import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/solutions', label: 'Solutions' },
    { path: '/architecture', label: 'Architecture' },
    { path: '/self-hosting', label: 'Self-Hosting' },
    { path: '/dashboard', label: 'Live Dashboard' },
    { path: '/resources', label: 'Resources' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm border-b border-green-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-green-400 text-2xl font-bold font-mono">MacMind</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-green-500/20 text-green-400'
                    : 'text-gray-300 hover:text-green-400 hover:bg-green-500/10'
                }`}
              >
                {item.label}
              </Link>
            ))}

            <a
              href="https://macmind.macpherson.ai"
              className="ml-4 px-4 py-2 rounded-md text-sm font-medium bg-green-500 text-black hover:bg-green-400 transition-colors"
            >
              Enter the Mind
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-md text-gray-300 hover:text-green-400 hover:bg-green-500/10"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-black/95 border-t border-green-500/20"
          >
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-3 py-2 rounded-md text-base font-medium ${
                    location.pathname === item.path
                      ? 'bg-green-500/20 text-green-400'
                      : 'text-gray-300 hover:text-green-400 hover:bg-green-500/10'
                  }`}
                >
                  {item.label}
                </Link>
              ))}

              <a
                href="https://macmind.macpherson.ai"
                className="block px-3 py-2 rounded-md text-base font-medium bg-green-500 text-black hover:bg-green-400 text-center"
              >
                Enter the Mind
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navigation;
